/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 홍보결과목록 > 관심표명자 상담일 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogInterestCouncelday.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { LoadPromoInterest } from './useSubmitPromoFilter'
import { useState } from 'react'
import { usePromoDialogInterest } from 'src/stores/PromoStore'
import DateRangePickerInterestDialogCouncel from './DateRangePickerInterestDialogCouncel'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const TitleWrapper = styled.span`
    font-size:16px;
    font-weight:500;
`
interface Props{
  result_id:number,
  school_class:string
}

const DialogInterestCouncelday = ({result_id,school_class}:Props) => {
    const setField = usePromoDialogInterest((state)=>state.setField)
    const [resetTrigger,setResetTrigger] = useState(0)
    const temp_startCouncel = usePromoDialogInterest((state)=>state.temp_startCouncel)
    const temp_endCouncel = usePromoDialogInterest((state)=>state.temp_endCouncel)
    const handleSubmit = async () => {
        await setField('startCouncel',temp_startCouncel)
        await setField('endCouncel',temp_endCouncel)
        LoadPromoInterest(result_id,school_class)
    }
    const onClickReset = ()=>{
        setResetTrigger((prev)=>prev+1)
    }
  return (
    <PageWrapper>
        <TitleWrapper>
            상담일
        </TitleWrapper>
        <DateRangePickerInterestDialogCouncel resetTrigger={resetTrigger}/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogInterestCouncelday